const networkErrorCooldown = {
  lastShown: 0,
  cooldownMs: 5000, // 5 seconds
};

class PopupManager {
  constructor() {
    this.popups = [];
    this.listeners = [];
  }

  addPopup(popup) {
    // Check if this is a network error and apply cooldown
    if (popup.message && popup.message.includes("Please connect your wallet to the selected network")) {
      const now = Date.now();
      if (now - networkErrorCooldown.lastShown < networkErrorCooldown.cooldownMs) {
        return; // Skip showing duplicate network errors
      }
      networkErrorCooldown.lastShown = now;
    }

    this.popups.push(popup);
    this.listeners.forEach((listener) => listener(popup));
  }

  removePopup(id) {
    this.popups = this.popups.filter(popup => popup.id !== id);
    this.listeners.forEach((listener) => listener({ id, remove: true }));
  }

  clearPopups() {
    this.popups = [];
    this.listeners.forEach((listener) => listener({ clear: true }));
  }

  subscribe(listener) {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter((l) => l !== listener);
    };
  }

  getPopups() {
    return this.popups;
  }
}

export const popupManager = new PopupManager();
